export default {"src":"https://webcdn.trailways.ca/_next/static/media/close-light.2ce22d3b.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};